import { Component } from 'react';
import { Modal, Table } from "react-bootstrap";

import { Col, Row, Container } from "react-bootstrap";
import RomData from '../../data/RomData';
import GameData from '../../mobx/GameData';
import coerceUnknownFields from '../../data/BaseGame';

export default class RomAddressOffsetDialog extends Component {

    constructor(props) {
        super(props);

        this.state = {
            smallRom: coerceUnknownFields(GameData.currentGame).smallRom
        }
    }

    render() {
        return (
            <Modal show={this.props.visible} fullscreen={false} onHide={this.props.onClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Rom Address Offsets</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="level-review-dialog">
                        <Container>
                            <Row>
                                <Col>
                                    <p className="mt-3">
                                        This shows the offsets this tool rewrites to update the rom. If you wanna hack things, these are some useful addresses.
                                    </p>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <Table>
                                        <thead>
                                            <tr>
                                                <th>Name</th>
                                                <th>Address</th>
                                                <th>Length</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {RomData.patches.map(patch => {
                                                const addr = this.state.smallRom ? (patch.smallRomAddress ?? patch.address) : patch.address,
                                                    len = this.state.smallRom ? (patch.smallRomLength ?? patch.length) : patch.length;
                                                return (<tr key={`patch-${patch.name}-${patch.symbol}`}>
                                                    <td>{patch.symbol.length ? patch.symbol.replace('_', '') : patch.name}</td>
                                                    <td>0x{addr.toString('16')}</td>
                                                    <td>{len || 1}</td>
                                                </tr>)
                                            })}
                                        </tbody>
                                    </Table>
                                </Col>
                            </Row>
                    </Container>
                    </div>
                </Modal.Body>
            </Modal>
        );
    }
}